import { __assign } from "tslib";
import React from 'react';
import MinimalDumbo from '../../../../DeviationViews/Thumb/Shop';
import s from './Commission.scss';
var CommissionThumbReactView = function (props) { return (React.createElement("div", { className: s['root'], style: { width: props.width, height: props.height } },
    React.createElement(MinimalDumbo, __assign({}, props)))); };
CommissionThumbReactView.displayName = 'CommissionThumbReactView';
export default CommissionThumbReactView;
//# sourceMappingURL=Commission.js.map